<template>
  <v-card>
    <h1 class="text-pagename text-xs-center">Set pop-up on app</h1>
    <v-card-text class="pt-0" v-if="!is_crop_image">
      <div class="text-xs-center">Recommended size : (920 x 1800)</div>
      <v-layout row wrap justify-center align-center>
        <v-flex xs12 sm3 class="pr-2 mx-4">
          <v-card :class="!popup_data.province_popup_status ? 'filter-close' : '' ">
            <v-switch
              color="primary"
              v-model="popup_data.province_popup_status"
              style="position:absolute;right:10px;z-index:10;"
            ></v-switch>
            <v-responsive :aspect-ratio="0.51/1">
              <v-img :src="popup_data.province_popup_image">
                <v-tooltip top>
                  <v-btn
                    fab
                    small
                    @click="$refs.ImageInput.click()"
                    depressed
                    class="add-btn elevation-5"
                    slot="activator"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <input
                    style="display:none;"
                    @change="onImageSelected"
                    type="file"
                    ref="ImageInput"
                    accept="image/*"
                  >
                  <span>Edit image</span>
                </v-tooltip>
              </v-img>
              <v-tooltip top v-if="!popup_data.province_popup_image">
                <v-btn
                  fab
                  small
                  @click="$refs.ImageInput.click()"
                  depressed
                  class="add-btn elevation-5"
                  slot="activator"
                >
                  <v-icon>add</v-icon>
                </v-btn>
                <input
                  style="display:none;"
                  @change="onImageSelected"
                  type="file"
                  ref="ImageInput"
                  accept="image/*"
                >
                <span>Add image</span>
              </v-tooltip>
            </v-responsive>
          </v-card>
          <div style="display:flex;justify-content:center;">
            <v-btn color="red" flat @click="reset()" :disabled="posting_data">Reset</v-btn>
            <v-btn
              color="green"
              flat
              @click="save()"
              :disabled="posting_data"
              :loading="posting_data"
            >Save</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-text v-else>
      <imageCropper
        :aspectRatio="0.51/1"
        :imageName="image_name"
        :imgSrc="imgURL"
        :height="300"
        @close="is_crop_image = false"
        @setImageName="image_name = $event"
        @getCroped="getCropped($event)"
        v-if="imgURL != ''"
      ></imageCropper>
    </v-card-text>
    <v-divider/>
  </v-card>
</template>

<script>

import imageCropper from "@/components/Plugins/imageCropper.vue";
import { mapState } from "vuex";
export default {
  components: {
    imageCropper
  },
  data: () => ({
    original_popup_data: {},
    change_image: 0,
    image_name: "",
    is_crop_image: false,
    posting_data: false,
    imgURL: null,
    rules: {
      required: value => !!value || "Required."
    }
  }),
  computed: {
    ...mapState({
      provinceData: state => state.fetchProvinceBack.provinceData,
      popup_data: state => state.fetchFoodSetAppBack.popup_data
    })
  },
  methods: {
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    async save() {
      this.posting_data = true;
      let form_data = new FormData();
      let obj1 = JSON.parse(JSON.stringify(this.popup_data));
      if (this.change_image == 0) {
        delete obj1.province_popup_image;
      } else {
        let image_file = this.dataURLtoFile(
          obj1.province_popup_image,
          this.image_name
        );
        form_data.append("province_popup_image", image_file);
      }
      form_data.append("province_popup_status", obj1.province_popup_status);
      let check = await this.$store.dispatch(
        "fetchFoodSetAppBack/updatePopupData",
        {
          province_id: this.findProvince(this.$route.params.province),
          form: form_data
        }
      );
      if (check == true) {
        this.change_image = 0;
        this.original_popup_data = JSON.parse(JSON.stringify(this.popup_data));
      }
      this.posting_data = false;
    },
    reset() {
      this.change_image = 0;
      this.$store.commit(
        "fetchFoodSetAppBack/getPopupData",
        JSON.parse(JSON.stringify(this.original_popup_data))
      );
    },
    onImageSelected(event) {
      let file = event.target.files[0];
      this.image_name = file.name;
      let reader = new FileReader();

      reader.addEventListener("load", () => {
        if (file.type == "image/gif") {
          this.getCropped(reader.result);
        } else {
          this.imgURL = reader.result;
          this.is_crop_image = true;
        }
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    getCropped(image_value) {
      this.popup_data.province_popup_image = image_value;
      this.change_image = 1;
      this.imgURL = null;
      // this.image_name = "";
    },
    splitProvince(province) {
      let province_set = "";
      let province_split = province.split(" ");
      for (let val of province_split) {
        province_set += val;
      }
      return province_set;
    },
    findProvince(province) {
      let result = null;
      for (let val of this.provinceData) {
        if (
          this.splitProvince(val.province_name_en.toLowerCase()) == province
        ) {
          result = val.province_id;
        }
      }
      return result;
    },
    async initialization() {
      await this.$store.dispatch(
        "fetchFoodSetAppBack/getPopupData",
        this.findProvince(this.$route.params.province)
      );
      this.original_popup_data = JSON.parse(JSON.stringify(this.popup_data));
    }
  },
  created() {
    this.initialization();
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href:  "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href:  "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "App setting",
        disabled: true
      },
      {
        text: "Set pop-up",
        disabled: true
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style scoped>
.add-btn {
  top: 42%;
  left: 40%;
}
.filter-close {
  background-color: gray;
  opacity: 0.5;
  transition: 0.5s;
  width: 100%;
  height: 100%;
}
</style>
